<div [class.add-top-margin]="addTopMargin" class="bg-gray-200 p-4 mb-8 text-center">
    Google AdSense Placeholder
</div>
